<!-- <div class="container" *ngIf="history" style="max-height:calc(50vh - 160px); overflow:auto">
    <div class="col-md-12">
        <app-timeline [timeline]="history" [req_history]="1"></app-timeline>
    </div>
</div> -->


<h2 mat-dialog-title>
    Approval History <span class="float-right">
        <i class="fa fa-times" (click)="close()"></i></span>
</h2>
<mat-dialog-content>
    <div class="container" *ngIf="history" style="max-height:calc(50vh - 160px); overflow:auto">
        <div class="col-md-12">
            <!-- <app-timeline [timeline]="history" [req_history]="req_id"></app-timeline> -->
            <div class="container">
                <div class="row counter">
                    <div class="activity-history" *ngFor="let item1 of history;let i = index;let isLast=last;">
                        <div class="activity-date-time" style="--line-num: 1;" data-content="i">
                            <div *ngFor="let item of item1;let j = index;let last=last;">
                                <div *ngIf="!item.approval_status">
                                    <span >
                                        <!-- <div *ngIf="!item.approval_status" style="padding-left: 1.5rem;">{{item.name}} has taken no action.{{item.lu_date | date: 'd-MMM-yyyy'}} {{item.lu_date | date: 'h:mm a'}}<br></div>
                                    <div *ngIf="item.approval_status" style="padding-left: 1.5rem;">{{item.name}} has taken no {{item.lu_date | date: 'd-MMM-yyyy'}} {{item.lu_date | date: 'h:mm a'}}.<br></div> -->
                                        <div style="padding-left: 2.5rem;">
                                            {{item.name}} has taken no action.
                                        </div>
                                    </span>
                                </div>
                                <div *ngIf="item.approval_status">
                                    <span >
                                        <!-- <div *ngIf="!item.approval_status" style="padding-left: 1.5rem;">{{item.name}} has taken no action.{{item.lu_date | date: 'd-MMM-yyyy'}} {{item.lu_date | date: 'h:mm a'}}<br></div>
                                    <div *ngIf="item.approval_status" style="padding-left: 1.5rem;">{{item.name}} has taken no {{item.lu_date | date: 'd-MMM-yyyy'}} {{item.lu_date | date: 'h:mm a'}}.<br></div> -->
                                    <div style="padding-left: 2.5rem;">  
                                    {{item.name}} has {{item.approval_status_title}} no
                                        {{item.lu_date | date: 'd-MMM-yyyy'}}
                                        {{item.lu_date | date: 'h:mm a'}}
                                    
                                </div>
                            </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</mat-dialog-content>